import React, { useState, useEffect, useCallback } from "react";
import { Table, Dropdown } from "antd";
import { useHistory } from "react-router-dom";
import {
  fetchAssetList,
  deleteAsset,
  TurnUnvailable,
  fetchAssetTreeList,
} from "../../redux/actions/action";
import { useDispatch, useSelector } from "react-redux";
import closeIcon from "../../assets/icons/x-circle.svg";
import deleteIcon from "../../assets/icons/DeleteIcon.svg";
import location from "../../assets/icons/location1.svg";
import tool from "../../assets/icons/tool.svg";
import aperture from "../../assets/icons/aperture.svg";
import Show from "../../assets/icons/Notshow.svg";
import Doc from "../../assets/icons/Document_2.svg";
import { Radio } from "@mui/material";
import { default as style } from "styled-components";
import Calendericon from "../../assets/icons/Calendar with interaction.svg";
import AppDatePicker from "../Common/AppDatePicker";
import AssemblyInstructionsPopup from "./AssemblyInstructions/AssemblyInstructionsPopup";

function TreeListTable({ className, expand, setExpand, query, setQuery }) {
  const history = useHistory();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [dropDownItemsHover, setDropDownItemsHover] = useState(false);
  const [querystring, setQuerystring] = useState("");
  const [perPageRequired, setPerPageRequired] = useState(10);
  const [pageNumber, setPageNumber] = useState(0);
  const [assemblyModal, showAssemblyModal] = useState(false);
  const companyId = window.localStorage.getItem("companyid");

  const [activeSort, setActiveSort] = useState("Assets Name");

  const [showSecondMenu, setShowSecondMenu] = useState(true);
  const [type, setType] = useState("Definitive");
  const [reason, setReason] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [tableData, setTableData] = useState();
  const assetsTreeList = useSelector((state) => state.user.fetchAssetTree);

  useEffect(() => {
    const addKeysToData = (data, parentKey) => {
      return data.map((item, index) => {
        const key = parentKey ? `${parentKey}-${index}` : `${index}`;
        const updatedItem = { ...item, key };
        if (item.children && item.children.length > 0) {
          updatedItem.children = addKeysToData(item.children, key);
        } else delete updatedItem.children;
        return updatedItem;
      });
    };

    if (assetsTreeList && assetsTreeList.data) {
      const updatedData = addKeysToData(assetsTreeList.data);
      setTableData(updatedData);
    }
  }, [assetsTreeList]);

  const BpIcon = style("span")(() => ({
    borderRadius: "50%",
    width: 16,
    height: 16,
    boxShadow:
      "dark" === "dark"
        ? "0 0 0 1px rgb(16 22 26 / 40%)"
        : "inset 0 0 0 1px rgba(16,22,26,.2), inset 0 -1px 0 rgba(16,22,26,.1)",
    backgroundColor: "dark" === "dark" ? "#FFFFFF" : "#f5f8fa",
    backgroundImage:
      "dark" === "dark"
        ? "linear-gradient(180deg,hsla(0,0%,100%,.05),hsla(0,0%,100%,0))"
        : "linear-gradient(180deg,hsla(0,0%,100%,.8),hsla(0,0%,100%,0))",
    ".Mui-focusVisible &": {
      outline: "2px auto rgba(19,124,189,.6)",
      outlineOffset: 2,
    },
    "input:hover ~ &": {
      backgroundColor: "dark" === "dark" ? "#FFFFFF" : "#ebf1f5",
    },
    "input:disabled ~ &": {
      boxShadow: "none",
      background:
        "dark" === "dark" ? "rgba(57,75,89,.5)" : "rgba(206,217,224,.5)",
    },
  }));

  const BpCheckedIcon = style(BpIcon)({
    backgroundColor: "#00246A",
    backgroundImage:
      "linear-gradient(180deg,hsla(0,0%,100%,.1),hsla(0,0%,100%,0))",
    "&:before": {
      display: "block",
      width: 0,
      height: 16,
      backgroundImage: "radial-gradient(#fff,#fff 28%,transparent 32%)",
      content: '""',
    },
    "input:hover ~ &": {
      backgroundColor: "#106ba3",
    },
  });

  const SetAssetUnavailibility = async (obj) => {
    var data = {
      assetId: obj.assetid,
    };

    if (type === "Temporary") {
      data["isTemporary"] = true;
      data["startDate"] = startDate;
      data["endDate"] = endDate;
    } else if (type === "Definitive") {
      data["isDefinitive"] = true;
      data["reason"] = reason;
    }

    var result = await TurnUnvailable(data);

    if (result) {
      refreshTableListData();
    }
  };

  const menu = (obj) => (
    <div
      style={{
        backgroundColor: "#FAFAFA",
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        gap: "10px",
        padding: "15px",
        borderRadius: "10px",
        position: "relative",
        paddingTop: "40px",
        marginTop: "-30px",
        zIndex: "9",
        boxShadow: "0px 5px 7px 0px #d4d4d4",
      }}
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
      }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          gap: "3px",
          position: "absolute",
          top: "10px",
          right: "15px",
          cursor: "pointer",
        }}
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          setShowSecondMenu(false);
        }}
      >
        {new Array(3).fill(true).map((item, index) => (
          <div
            style={{
              backgroundColor: "#1F1F1F",
              width: "3px",
              height: "3px",
              borderRadius: "2px",
            }}
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              setShowSecondMenu(false);
            }}
          ></div>
        ))}
      </div>

      {showSecondMenu && (
        <div
          style={{
            position: "absolute",
            right: "16vw",
            background: "white",
            top: "3vh",
            zIndex: "999",
            width: "14vw",
            minHeight: "40vh",
            borderRadius: "5px",
            padding: "10px",
            boxShadow: "rgb(212, 212, 212) 0px 1px 5px 0px",
          }}
        >
          <div className="row selection">
            <div className="col">Turn Unavailable</div>
            <div
              className="col-3"
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                setShowSecondMenu(false);
              }}
            >
              {" "}
              <img src={closeIcon} alt="" />
            </div>
          </div>
          <div className="fc">
            <div style={{ display: "flex" }}>
              <Radio
                checked={type === "Definitive"}
                onClick={() => setType("Definitive")}
                value="Definitive"
                name="radio-buttons"
                inputProps={{ "aria-label": "A" }}
                checkedIcon={<BpCheckedIcon />}
                icon={<BpIcon />}
                size="small"
                disableRipple={true}
                disableFocusRipple={true}
                sx={{
                  ":hover": {
                    backgroundColor: "transparent",
                  },
                }}
              />
              <p
                onClick={() => setType("Definitive")}
                style={{
                  fontSize: "x-small",
                  marginTop: "10px",
                  cursor: "pointer",
                }}
              >
                Definitive
              </p>
            </div>
            <textarea
              name="description"
              className={"text-description-pop-1"}
              style={{
                marginLeft: "8px",
                maxWidth: "clamp(155px, 8.204vw, 10.204vw)",
              }}
              placeholder={"Type a reason"}
              // value={""}
              onChange={(e) => {
                setReason(e.target.value);
              }}
            />
            <div>
              <div style={{ display: "flex" }}>
                <Radio
                  checked={type === "Temporary"}
                  value="Temporary"
                  name="radio-buttons"
                  inputProps={{ "aria-label": "A" }}
                  checkedIcon={<BpCheckedIcon />}
                  onClick={() => setType("Temporary")}
                  icon={<BpIcon />}
                  size="small"
                  disableRipple={true}
                  disableFocusRipple={true}
                  sx={{
                    ":hover": {
                      backgroundColor: "transparent",
                    },
                  }}
                />
                <p
                  onClick={() => setType("Temporary")}
                  style={{
                    fontSize: "x-small",
                    marginTop: "10px",
                    cursor: "pointer",
                  }}
                >
                  Temporary
                </p>
              </div>

              <label
                style={{
                  display: "flex",
                  width: "94%",
                  marginLeft: "8px",
                }}
              >
                <p style={{ fontSize: "12px", opacity: ".5" }}>
                  From&nbsp;&nbsp;&nbsp;
                </p>
                <img
                  style={{ height: "15px", marginTop: "3px" }}
                  src={Calendericon}
                  alt="calender"
                />
                <AppDatePicker
                  onSelect={(d, event) => {
                    event.preventDefault();
                  }}
                  inputClassNames={"ms-1 equipment-date"}
                  dateFormat="dd/MM/yyyy"
                  className="calender-icon-date"
                  onChange={setStartDate}
                  placeholderText="dd/mm/yyyy"
                  selected={startDate}
                />
              </label>
              <label
                style={{
                  display: "flex",
                  marginLeft: "7px",
                  width: "94%",
                }}
              >
                <p style={{ fontSize: "12px", opacity: ".5" }}>
                  To&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                </p>
                <img
                  style={{ height: "16px", marginTop: "3px" }}
                  src={Calendericon}
                  alt="calender"
                />
                <AppDatePicker
                  onSelect={(d, event) => {
                    event.preventDefault();
                  }}
                  inputClassNames={"ms-1 equipment-date"}
                  dateFormat="dd/MM/yyyy"
                  className="calender-icon-date"
                  onChange={setEndDate}
                  placeholderText="dd/mm/yyyy"
                  selected={endDate}
                />
              </label>
              <div className="confirm-btn-div">
                <button
                  className="confirm-btn"
                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    setShowSecondMenu(false);
                    SetAssetUnavailibility(obj);
                  }}
                >
                  Confirm
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Turn Availibility */}
      <div
        className="selection"
        style={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          gap: "15px",
          cursor: "pointer",
        }}
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          setShowSecondMenu(true);
        }}
      >
        <img
          src={Show}
          alt=""
          style={{ color: dropDownItemsHover ? "#00246A" : "inherit" }}
        />
        <p
          style={{
            margin: 0,
            color: dropDownItemsHover ? "#00246A" : "inherit",
          }}
          onMouseEnter={() => {
            setDropDownItemsHover(true);
          }}
          onMouseLeave={() => {
            setDropDownItemsHover(false);
          }}
        >
          Turn Unavailable
        </p>
      </div>

      {/* Create Maintainace */}
      <div
        className="selection"
        style={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          gap: "15px",
          cursor: "pointer",
        }}
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          setShowSecondMenu(false);

          var data = {
            action: "CREATEMAINTAINANCE",
          };

          window.localStorage.setItem("assetId", obj.assetid);
          window.localStorage.setItem("assetId", obj.assetId);
          localStorage.setItem("activeTab", "maintenance");

          if (obj.assetType === "Part")
            history.push("/asset-management/update-part", data);
          else if (obj.assetType === "Equipment")
            history.push("/asset-management/update-equipment", data);
          else history.push("/asset-management/update-facility", data);

          // history.push("/asset-management/update-asset", data);
        }}
      >
        <img
          src={tool}
          alt=""
          style={{ color: dropDownItemsHover ? "#00246A" : "inherit" }}
        />
        <p
          style={{
            margin: 0,
            color: dropDownItemsHover ? "#00246A" : "inherit",
          }}
          onMouseEnter={() => {
            setDropDownItemsHover(true);
          }}
          onMouseLeave={() => {
            setDropDownItemsHover(false);
          }}
        >
          Create Maintenance
        </p>
      </div>

      {/* Create PO */}
      <div
        className="selection"
        style={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          gap: "15px",
          cursor: "pointer",
        }}
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          setShowSecondMenu(false);
          history.push("/add-purchasing-order");
        }}
      >
        <img
          src={Doc}
          alt=""
          style={{ color: dropDownItemsHover ? "#00246A" : "inherit" }}
        />
        <p
          style={{
            margin: 0,
            color: dropDownItemsHover ? "#00246A" : "inherit",
          }}
          onMouseEnter={() => {
            setDropDownItemsHover(true);
          }}
          onMouseLeave={() => {
            setDropDownItemsHover(false);
          }}
        >
          Create PO
        </p>
      </div>

      {/* Assembly Instruction */}
      <div
        className="selection"
        style={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          gap: "15px",
          cursor: "pointer",
        }}
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          setShowSecondMenu(false);
          showAssemblyModal(true);
          window.localStorage.setItem("assetId", obj.assetid);
          window.localStorage.setItem("assetId", obj.assetid);
        }}
      >
        <img
          src={aperture}
          alt=""
          style={{ color: dropDownItemsHover ? "#00246A" : "inherit" }}
        />
        <p
          style={{
            margin: 0,
            color: dropDownItemsHover ? "#00246A" : "inherit",
          }}
          onMouseEnter={() => {
            setDropDownItemsHover(true);
          }}
          onMouseLeave={() => {
            setDropDownItemsHover(false);
          }}
        >
          Assembly Instructions
        </p>
      </div>

      {/* Delete */}
      <div
        className="selection"
        style={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          gap: "15px",
          cursor: "pointer",
        }}
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          setShowSecondMenu(false);
          setLoading(true);
          dispatch(deleteAsset(obj.assetid));
          setTimeout(() => {
            dispatch(
              fetchAssetList(
                pageNumber,
                perPageRequired,
                activeSort,
                querystring,
              ),
            );
          }, 300);

          setLoading(false);
        }}
      >
        <img
          src={deleteIcon}
          alt=""
          style={{ color: dropDownItemsHover ? "#00246A" : "inherit" }}
        />
        <p
          style={{
            margin: 0,
            color: dropDownItemsHover ? "#00246A" : "inherit",
          }}
          onMouseEnter={() => {
            setDropDownItemsHover(true);
          }}
          onMouseLeave={() => {
            setDropDownItemsHover(false);
          }}
        >
          Delete
        </p>
      </div>
    </div>
  );

  const columns = [
    {
      title: "Asset Name",
      dataIndex: "assetName",
      key: "assetName",
      width: "30%",
      render: (name, obj) => {
        return (
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              gap: "10px",
              cursor: "pointer",
            }}
          >
            <img
              src={
                obj.assetType === "Part"
                  ? tool
                  : obj.assetType === "Equipment"
                    ? aperture
                    : location
              }
              alt=""
              style={{
                width: "16px",
                height: "16px",
                marginRight: "15px",
                cursor: "pointer",
              }}
            />
            <div>{name ?? "-"}</div>
          </div>
        );
      },
    },
    {
      key: "description",
      dataIndex: "description",
      title: "Asset Description",
      width: "30%",
      ellipsis: {
        showTitle: true,
      },
      render: (description, obj) => description ?? "-",
    },
    {
      key: "internalId",
      dataIndex: "internalId",
      title: "Internal ID",
      width: "13%",
      render: (internalId, obj) => internalId ?? "-",
    },
    {
      key: "assetLocation",
      dataIndex: "assetLocation",
      title: "Asset Location",
      width: "20%",
      ellipsis: {
        showTitle: true,
      },
      render: (assetLocation, obj) => assetLocation ?? "-",
    },
    {
      key: "category",
      dataIndex: "category",
      title: "Category",
      width: "20%",
      render: (category, obj) => (
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <div>{category ?? "-"}</div>
          <Dropdown
            overlay={() => menu(obj)}
            disabled={obj.isAssetUnavailable}
            trigger={"click"}
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              setShowSecondMenu(false);
            }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                flexDirection: "column",
                gap: "3px",
                cursor: "pointer",
                width: "20px",
              }}
            >
              {new Array(3).fill(true).map((item, index) => (
                <div
                  style={{
                    backgroundColor: "#1F1F1F",
                    width: "3px",
                    height: "3px",
                    borderRadius: "2px",
                    cursor: "pointer",
                  }}
                ></div>
              ))}
            </div>
          </Dropdown>
        </div>
      ),
    },
  ];

  const refreshTableListData = useCallback(() => {
    const payload = {
      companyId,
    };
    dispatch(fetchAssetTreeList(payload));
  }, [dispatch, companyId]);

  useEffect(() => {
    if (companyId) {
      refreshTableListData();
    }
  }, [companyId, refreshTableListData, expand]);

  const getExpandedRowKeys = (data) => {
    let keys = [];
    data.forEach((item) => {
      keys.push(item.key);
      if (item.children && item.children.length > 0 && expand) {
        keys = keys.concat(getExpandedRowKeys(item.children));
      }
    });
    return keys;
  };

  const expandedRowKeys = expand ? getExpandedRowKeys(tableData ?? []) : [];
  return (
    <>
      <div className="pb-4 treeTable" style={{ marginTop: "0" }}>
        <div className={`${className} assets-list-wrapper`}>
          <Table
            columns={columns}
            // dataSource={tableData ?? []}
            dataSource={(tableData ?? []).filter((item) => {
              if (!query) return true; // Show all if query is empty
              const q = query.toLowerCase();
              return (
                item.assetName?.toLowerCase().includes(q) ||
                item.description?.toLowerCase().includes(q) ||
                item.internalId?.toLowerCase().includes(q) ||
                item.assetLocation?.toLowerCase().includes(q) ||
                item.category?.toLowerCase().includes(q)
              );
            })}
            pagination={false}
            loading={loading}
            onRow={(record, rowIndex) => {
              return {
                onClick: (event) => {
                  window.localStorage.setItem("assetId", record.assetid);
                  window.localStorage.setItem("assetId", record.assetId);
                  localStorage.setItem("activeTab", "general");
                  if (record.assetType === "Part")
                    history.push("/asset-management/update-part");
                  else if (record.assetType === "Equipment")
                    history.push("/asset-management/update-equipment");
                  else history.push("/asset-management/update-facility");
                }, // click row
              };
            }}
            rowClassName={(record) =>
              record.isAssetUnavailable && "disabled-row"
            }
            {...(expand ? { expandedRowKeys: expandedRowKeys } : {})}
          />
        </div>
      </div>
      {assemblyModal && (
        <AssemblyInstructionsPopup
          show={assemblyModal}
          onHide={() => showAssemblyModal(false)}
          backdrop="static"
          keyboard={false}
          //  handleCancel={handleCancel}
        />
      )}
    </>
  );
}

export default TreeListTable;
